import { loadTranslations } from 'react-redux-i18n'
import { store } from '../../../../../app/store'

store.dispatch(
  loadTranslations({
    en: {
      ...store.getState().i18n.translations.en,
      userManagement: {
        ...store.getState().i18n.translations.en.userManagement,
        orderManagement: {
          ...store.getState().i18n.translations.en.userManagement
            .orderManagement,
          orderDetail: {
            BACK_TO_SUBSCRIPTION_PAYMENT: 'Back to Subscription & Payment',
            DETAIL_ORDER: 'Detail Order',
            ORDER_INFORMATION: 'Order Information',
            ORDER_DETAILS: 'Order Details',
            GO_TO_DOWNLOADED_FILES: 'Go to Downloaded Files',

            ORDER_NUMBER: 'Order Number',
            ORDER_STATUS: 'Order Status',
            DATE_ORDERED: 'Date Ordered',
            PAYMENT_STATUS: 'Payment Status',
            PAYMENT_METHOD: 'Payment Method',
            TOTAL_PRICE: 'Total Price',
            TOTAL_TRADE_DISCOUNT_ON_PRODUCT: 'Total Trade Discount On Product',
            TRADE_DISCOUNT_ON_ORDER: 'Trade Discount On Order',
            TOTAL: 'Total',
            NOTE_CANCEL_BTN:
              'If you want to cancel, you should send request in 24 hours. Your request will be taken into account based on order status.',
            COMPANY_NAME: 'Company Name',
            TYPE: 'Type',
            DESCRIPTION: 'Description',
            LANGUAGE: 'Language',
            CURRENCY: 'Currency<br/>(Unit)',
            ADDITIONAL_CURRENCY:
              'Additional Currency for<br/>Financial Statement<br/>(Unit)',
            FILE_TYPE: 'File Type',
            DELIVERY_DATE: 'Delivery Date',
            STATUS: 'Status',
            PRICE: 'Price',
            REPORT: 'Report',
            DOWNLOAD: 'Download',
            DOWNLOAD_CONFIRMATION: 'Download Confirmation',
            CANCEL_ORDER: 'Cancel Order',

            ALL: 'All',
            TYPE_VERSION: 'Type<br/>(Version)',
            ENGLISH: 'English',
            VIETNAMESE: 'Vietnamese',
            READY_TO_USE: 'Ready - to - use',
            ON_REQUEST: 'On Request',
            AVAILABLE_FS_DATA: 'Latest Available FS data',
            DATE_CREATED: 'Date created',
            REPORTING_YEAR: 'Reporting year',
            UNCONSOLIDATED: 'Separate',
            CONSOLIDATED: 'Consolidated',
            AUDITED: 'Audited',
            UNAUDITED: 'Unaudited',
            DIRECT: 'Direct',
            INDIRECT: 'Indirect',
            SELECTED_DATA_BLOCKS: 'Selected data blocks',
            SELECTED_CRITERIA: 'Selected Criteria',
            TOTAL_INFORMATION: 'Total Information',
            SORT_BY: 'Sort By',
            FILE: 'File',
            NUMBER_OF_COMPANIES: 'Number of Companies',
            VOLUME: 'Volume',

            HEAD_OFFICE: 'Head Office',
            HN_ADDRESS:
              'Level 10, Peakview Tower, 36 Hoang Cau, O Cho Dua Ward, Hanoi, Vietnam',
            PHONE: 'Tel: ',
            HCM_BRANCH: 'Ho Chi Minh Branch',
            HCM_ADDRESS:
              'Suite 1682, Level 16, Bitexco Financial Tower, 2 Hai Trieu Street, Sai Gon Ward, Ho Chi Minh City, Vietnam',

            CANCEL_QUESTION: 'Do you want to cancel this order?',
            CONFIRM_CANCEL_MESS: 'Your order has been cancelled.',
            CONFIRM_CANCEL_REQUEST_MESS: `Your cancel request was submitted. We will notify you by email after verifying it. Kindly check your inbox regularly for updates.
            <br/> Thank you for using our service!`,

            EXPIRED_FILE: 'Expired file',
            NO_DATA: 'No items match your search',
          },
        },
      },
    },
    vi: {
      ...store.getState().i18n.translations.vi,
      userManagement: {
        ...store.getState().i18n.translations.vi.userManagement,
        orderManagement: {
          ...store.getState().i18n.translations.vi.userManagement
            .orderManagement,
          orderDetail: {
            BACK_TO_SUBSCRIPTION_PAYMENT: 'Quay về Tài Khoản và Thanh Toán',
            DETAIL_ORDER: 'Chi Tiết Đơn Hàng',
            ORDER_INFORMATION: 'Thông Tin Đơn Hàng',
            ORDER_DETAILS: 'Chi Tiết Đơn Hàng',
            GO_TO_DOWNLOADED_FILES: 'Đi tới Tài Liệu Tải Xuống',

            ORDER_NUMBER: 'Mã Đơn Hàng',
            ORDER_STATUS: 'Trạng Thái Đơn Hàng',
            DATE_ORDERED: 'Ngày Đặt Hàng',
            PAYMENT_STATUS: 'Trạng Thái Thanh Toán',
            PAYMENT_METHOD: 'Phương Thức Thanh Toán',
            TOTAL_PRICE: 'Tổng Tiền',
            TOTAL_TRADE_DISCOUNT_ON_PRODUCT: 'Tổng CKTM Cho Sản Phẩm',
            TRADE_DISCOUNT_ON_ORDER: 'CKTM Cho Đơn Hàng',
            TOTAL: 'Tổng Thanh Toán',

            COMPANY_NAME: 'Tên Công Ty',
            TYPE: 'Loại',
            DESCRIPTION: 'Mô Tả',
            LANGUAGE: 'Ngôn Ngữ',
            CURRENCY: 'Tiền Tệ<br/>(Đơn Vị Tiền Tệ)',
            ADDITIONAL_CURRENCY: 'Tiền Tệ Bổ Sung cho<br/>BCTC<br/>(Đơn Vị)',
            FILE_TYPE: 'Định Dạng Tài Liệu',
            DELIVERY_DATE: 'Ngày Phát Hành',
            STATUS: 'Trạng Thái',
            PRICE: 'Giá',
            REPORT: 'Báo Cáo',
            DOWNLOAD: 'Tải Xuống',
            DOWNLOAD_CONFIRMATION: 'Tải Xác Nhận',
            CANCEL_ORDER: 'Huỷ Đơn Hàng',

            ALL: 'Tất cả',
            TYPE_VERSION: 'Loại<br/>(Phiên bản)',
            ENGLISH: 'Tiếng Anh',
            VIETNAMESE: 'Tiếng Việt',
            READY_TO_USE: 'Phiên Bản Sẵn Có',
            ON_REQUEST: 'Phiên Bản Mới',
            AVAILABLE_FS_DATA: 'Dữ Liệu BCTC Có Sẵn Gần Nhất',
            DATE_CREATED: 'Ngày tạo',
            REPORTING_YEAR: 'Năm báo cáo',
            UNCONSOLIDATED: 'Riêng lẻ',
            CONSOLIDATED: 'Hợp nhất',
            AUDITED: 'Kiểm toán',
            UNAUDITED: 'Chưa kiểm toán',
            DIRECT: 'Trực tiếp',
            INDIRECT: 'Gián tiếp',
            SELECTED_DATA_BLOCKS: 'Dữ liệu đã chọn:',
            SELECTED_CRITERIA: 'Tiêu Chí Đã Lựa Chọn',
            TOTAL_INFORMATION: 'Thông Tin Kết Quả',
            SORT_BY: 'Sắp Xếp Theo',
            FILE: 'Tài Liệu',
            NUMBER_OF_COMPANIES: 'Số Lượng Công Ty',
            VOLUME: 'Số Lượng',

            HEAD_OFFICE: 'Trụ Sở Chính',
            HN_ADDRESS:
              'Tầng 10, Tòa Nhà Peakview Tower, 36 Hoàng Cầu, Phường Ô Chợ Dừa, Thành phố Hà Nội, Việt Nam',
            PHONE: 'Điện thoại: ',
            HCM_BRANCH: 'Chi nhánh Tp.Hồ Chí Minh',
            HCM_ADDRESS:
              'Phòng 1682, Tầng 16, Tòa nhà Bitexco Financial Tower, số 2 đường Hải Triều, Phường Sài Gòn, TP Hồ Chí Minh, Việt Nam',
            NOTE_CANCEL_BTN:
              'Nếu bạn muốn hủy, bạn nên gửi yêu cầu trong vòng 24 giờ. Yêu cầu hủy của bạn sẽ được cân nhắc tùy vào tình trạng xử lý đơn hàng',
            CANCEL_QUESTION: 'Bạn có muốn hủy đơn hàng không?',
            CONFIRM_CANCEL_MESS: 'Đơn hàng của bạn đã được hủy.',
            CONFIRM_CANCEL_REQUEST_MESS: `Yêu cầu của bạn đã được gửi thành công. Chúng tôi sẽ thông báo kết quả sau khi xác minh yêu cầu của bạn qua email. Vui lòng, kiểm tra hộp thư của bạn thường xuyên để nắm được các cập nhật.
            Cảm ơn bạn đã sử dụng dịch vụ của FiinGate!`,

            EXPIRED_FILE: 'File hết hạn',
            NO_DATA: 'Không có mục nào phù hợp',
          },
        },
      },
    },
  }),
)
